import { render, staticRenderFns } from "./SettingsTabSources.vue?vue&type=template&id=a9944e6a&"
import script from "./SettingsTabSources.vue?vue&type=script&lang=js&"
export * from "./SettingsTabSources.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTabSources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports